module.exports = __webpack_public_path__ + "img/gonetwork1_1.a5de4125.png";